import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@stores/auth/authStore";
import { canAccessPlatformPermission } from "@lib/permissions";

export const AnyPermissionRoute: React.FC<{
    permissions: string[];
    children: React.ReactNode;
}> = ({ permissions: required, children }) => {
    const granted = useAuthStore((s) => s.permissions);
    const ok = required.some((p) => canAccessPlatformPermission(granted, p));
    if (!ok) {
        return <Navigate to="/" replace />;
    }
    return <>{children}</>;
};
